/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-12 13:10:17
 * @FilePath: \senlan-ai-ui\src\utils.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { message } from 'antd'
import type { GetProp, UploadProps } from 'antd'
import type { ChatMessage } from './stores/conversation.store'

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0]

// 限制文件大小
export const litFileSize = (file: FileType, size: number) => {
  const isLt2M = file.size / 1024 / size < 1
  if (!isLt2M) {
    message.error(`Image must smaller than ${size}KB!`)
  }
  return isLt2M
}

export const decoder = new TextDecoder('utf-8')

// 聊天持久化消息映射为UI表示
export const mapStoredMessagesToUIMessages = (
  messages: ChatMessage[]
): any[] => {
  if (!messages || !Array.isArray(messages)) {
    console.warn('无效的消息数组:', messages)
    return []
  }

  return (
    messages
      // .filter((msg) => !msg.isError) // 过滤掉加载中的消息
      ?.map((msg) => {
        return {
          id: msg.messageId,
          text: msg.content ?? '',
          thinkContent: msg.thinkContent ?? '',
          onlineSearchResults:
            msg.medium?.onlineSearchResults || msg.onlineContent || [],
          sender: msg.role === 'USER' ? 'USER' : 'ASSISTANT',
          timestamp: msg.createTime,
          isError: msg.isError,
          isFinished: msg.isFinished,
          images:
            msg.medium?.images || [],
          docs:
            msg.medium?.docs || [],
        }
      }) ?? []
  )
}

export const scrollToBottom = (container: HTMLElement | null) => {
  if (!container) return
  requestAnimationFrame(() => {
    const lastMessage = container.lastElementChild as HTMLElement

    if (lastMessage) {
      // 使用平滑滚动
      lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  })
}

export const throttle = (func: (...args: any[]) => void, time: number) => {
  let inThrottle: boolean
  return function (...args: any[]) {
    const context = this
    if (!inThrottle) {
      func.apply(context, args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), time)
    }
  }
}
// 检查blob内容的函数
export const inspectBlob = async (blob: Blob): Promise<void> => {
  if (blob.size === 0) {
    console.error('Blob is empty (size 0)')
    return
  }

  console.log('Blob size:', blob.size, 'bytes')
  console.log('Blob type:', blob.type)

  // 读取blob前100字节来检查内容类型
  const slice = blob.slice(0, Math.min(100, blob.size))
  const buffer = await slice.arrayBuffer()
  const view = new Uint8Array(buffer)

  let hexString = ''
  for (let i = 0; i < view.length; i++) {
    hexString += view[i].toString(16).padStart(2, '0') + ' '
    if ((i + 1) % 16 === 0) hexString += '\n'
  }

  console.log('Blob content preview (hex):', hexString)

  // 检查PNG魔术数字 (89 50 4E 47 0D 0A 1A 0A)
  if (view.length >= 8) {
    const isPNG =
      view[0] === 0x89 &&
      view[1] === 0x50 &&
      view[2] === 0x4e &&
      view[3] === 0x47 &&
      view[4] === 0x0d &&
      view[5] === 0x0a &&
      view[6] === 0x1a &&
      view[7] === 0x0a

    console.log('Is PNG:', isPNG)
  }

  // 检查JPEG魔术数字 (FF D8 FF)
  if (view.length >= 3) {
    const isJPEG = view[0] === 0xff && view[1] === 0xd8 && view[2] === 0xff

    console.log('Is JPEG:', isJPEG)
  }
}
export const formatSize = (bytes: number) => {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}
// 验证URL
export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}